import { error } from 'utils/tools/airhorn'

export const log = (group: string, thrownError?: Error, context?: object) => {
  error(group, { error: thrownError, metadata: context })
}
